import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import { Button, Card, PageShell } from 'src/design-system';
import { setAuthState } from 'src/store/user/userSlice';
import UsersApi from 'api/users';
import Loader from 'src/components/Loader/Loader';
import { trackGoogleAdsTrialSignup } from 'src/utils/googleAdsConversion';

const Callback = () => {
  const { isAuthenticated, getAccessTokenSilently, loginWithRedirect, logout, isLoading } =
    useAuth0();
  const dispatch = useDispatch();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      getAccessTokenSilently()
        .then(async () => {
          const { data } = await UsersApi.fetchCurrentUser();
          const { data: flags } = await UsersApi.fetchFeatureFlags();

          dispatch(
            setAuthState({
              isAuthenticated: true,
              isLoading: false,
              user: data.user,
              featureFlags: flags,
              campaignLimits: data.campaignLimits,
              crispToken: data.crispToken
            })
          );
          trackGoogleAdsTrialSignup(data.user.id);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
          if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
            console.error('Response headers:', error.response.headers);
          } else if (error.request) {
            console.error('Request data:', error.request);
          } else {
            console.error('Error message:', error.message);
          }
          setFailed(true);
        });
    } else {
      loginWithRedirect({
        appState: { returnTo: '/' },
        authorizationParams: { prompt: 'login' }
      });
    }
  }, [isAuthenticated, getAccessTokenSilently, dispatch, loginWithRedirect, isLoading]);

  if (failed) {
    return (
      <PageShell centered contentClassName="max-w-md">
        <Card className="w-full">
          <Card.Content className="text-center">
            <h2 className="mb-2 text-xl font-semibold tracking-tight">Something went wrong</h2>
            <p className="mb-4 text-default-500">
              We couldn't load your account. Please try again.
            </p>
            <Button
              variant="primary"
              className="w-full mb-2"
              onPress={() => {
                setFailed(false);
                loginWithRedirect({ appState: { returnTo: '/' } });
              }}>
              Try Again
            </Button>
            <Button
              variant="ghost"
              className="w-full"
              onPress={() =>
                logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
              }>
              Logout
            </Button>
          </Card.Content>
        </Card>
      </PageShell>
    );
  }

  return <Loader />;
};

export default Callback;
